import styled from "styled-components";

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 28px 0;
  width: 100%;
`;

export const PaginationContent = styled.div`
  padding: 12px 18px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
